import React, {useState} from "react";
import {Button, Checkbox, FormControlLabel, Switch, TextField} from "@mui/material";
import {useHistory} from "react-router-dom";

let link = 'https://desexing.spca.nz/images/assets/1586/1/Voucher%20Terms%20and%20Conditions.pdf';

/*
 *  Start page
 *  @param userAccount - user account details
 *  @param setOrderDescription - set order description
 *  @param setStep - set step
 */
export default function OutreachStartPage({userAccount,setOrderDescription,setStep, setMicrochipOnly, microchipOnly}) {

    const history = useHistory();
    const [arr, setArrFn] = useState([]);
    const [desc, setDesc] = useState('');

    const [c1, setC1] = useState(false);
    const [c2, setC2] = useState(false);
    const [c3, setC3] = useState(false);
    const [c4, setC4] = useState(false);
    const [acceptTerms, setAcceptTerms] = React.useState(false);

    function setArr(checked, val) {
        let d = [...arr];
        if (checked) {
            d.push(val);
        } else {
            d = d.filter((itm) => itm !== val);
        }
        d = [...new Set(d)];
        d = (desc !== '') ? [...d, desc] : d;
        setArrFn(d);
        // setOrderDescription(d.join('##'));
        console.log(d.join(','));
    }

    window.gtag('set', 'page_path', '#0 - Landing page');
    window.gtag('event', 'page_view');
    window.gtag('event', 'action', {category: 'User', action: "Loaded start page"})
    return (
        <div className={"hero"} style={{paddingTop:20}}>

            <h2>
                Hi, {userAccount.name}
            </h2>
            <h2 className={"h2-bold"}>
            Welcome to the SPCA Desexing Outreach Portal
            </h2>
           
            <h2>
                You can access your issued and redeemed vouchers <a href={""} onClick={(e) => {e.preventDefault(); history.push("/logs");}}>here</a>.
            </h2>
            <div style={{
                background: "lightgray",
                padding: 20
            }}>
                <div style={{textAlign: 'left'}}>
                    <div><strong>Background information required (tick all that apply):</strong></div>
                    <p><FormControlLabel control={<Checkbox checked={c1} onChange={(e) => {
                        setC1(e.target.checked);
                        setArr(e.target.checked, "Is this person struggling financially to pay for desexing?")
                    }}/>} label="Is this person struggling financially to pay for desexing?"/></p>
                    <p><FormControlLabel control={<Checkbox checked={c2} onChange={(e) => {
                        setC2(e.target.checked);
                        setArr(e.target.checked, 'Has the animal had multiple litters?')
                    }}/>} label="Has the animal had multiple litters?"/></p>
                    <p><FormControlLabel control={<Checkbox checked={c3} onChange={(e) => {
                        setC3(e.target.checked);
                        setArr(e.target.checked, 'Is this animal at risk of negative animal welfare outcomes if not desexed?')
                    }}/>} label="Is this animal at risk of negative animal welfare outcomes if not desexed?"/></p>
                    <p><FormControlLabel control={<Checkbox checked={c4} onChange={(e) => {
                        setC4(e.target.checked);
                        setArr(e.target.checked, "Is desexing the animal part of an agreement the person has with your organisation?")
                    }}/>} label="Is desexing the animal part of an agreement the person has with your organisation?"/></p>
                    <p>
                        <TextField inputProps={{maxLength: 50}} placeholder={'Other (max 50 characters)'} value={desc}
                                   onChange={(e) => setDesc(e.target.value)} fullWidth/>
                    </p>
                </div>
                {/* <small>If the MOP does not meet these criteria, please discuss other options with them. Refer to the
                    Community Desexing Process.</small> */}
            </div>
            <div style={{width:'100%', textAlign:'center', verticalAlign:'center'}}>
                <div style={{margin:'0 auto',textAlign:'center', verticalAlign:'center'}}>
                    <ShowTermsAcceptance acceptTerms={acceptTerms} setAcceptTerms={setAcceptTerms} />
                </div>
            </div>
            <div style={{width:'100%', textAlign:'center', verticalAlign:'center'}}>
                <div style={{margin:'0 auto',padding:'0 0 20px 0 ',textAlign:'center', verticalAlign:'center'}}>
                    <FormControlLabel control={<Switch checked={microchipOnly} onChange={e => setMicrochipOnly(e.target.checked)} /> } label={<>Select this option if you only need microchipping (must already be desexed)</>} />
                </div>
            </div>
            <div>
                <Button
                    disabled={
                        (!c1 && !c2 && !c3 && !c4 && desc === '') || !acceptTerms
                    }
                    onClick={() => {
                        window.gtag('event', 'action', {
                            category: 'User',
                            action: 'Clicked apply now'
                        });
                        setOrderDescription([...arr, desc].join('##'));
                        setStep(1)
                    }}
                    size="small" sx={{
                    fontSize: "1.6em",
                    fontWeight: 600,
                    marginLeft: 0,
                    m: 0
                }} variant="contained"
                >Click here to issue a voucher</Button>
            </div>
            <div className={"content-small"}>
                The information you provide will be given to the Veterinary Clinic you have selected. This information
                will be used to help with bookings. For more information on our privacy policy please visit our
                website <a href={"https://www.spca.nz/privacy"} target={"_blank"}>https://www.spca.nz/privacy</a>.
            </div>
        </div>
    )
}


function ShowTermsAcceptance({ acceptTerms, setAcceptTerms }) {
    let text = <>I confirm the member of the public is aware of, understands and agrees to the <a href={link} referrerPolicy="no-referrer" target="_blank">terms and conditions</a>.</>;
    return (
        <div style={{padding:20}}>
            <FormControlLabel control={<Switch value={acceptTerms} onChange={(e) => setAcceptTerms(e.target.checked)} />} label={text} />
        </div>
    )
}
